import { EAdSectionBidStatus } from 'types/adManagement';
import { IFilterItem } from 'types/common';
import TranslatedLabel from 'components/TranslatedLabel';

export const MAX_AD_BID_BUDGET = 6500;

export const AD_BID_STATUS_FILTERS_CONFIG: IFilterItem[] = Object.values(EAdSectionBidStatus).map((value) => ({
	value,
	text: (
		<TranslatedLabel
			nameSpace='ad-management'
			i18nKey={value}
			extra={{ keyPrefix: 'enums.EAdSectionBidStatus' }}
		/>
	),
}));
